import {useRouteLoaderData} from '@remix-run/react'
import React, {useEffect, useState} from 'react'
import {BrgIconClose} from '~/icons/brg-icon-close'
import {BrgIconPartnerWithUs} from '~/icons/brg-icon-partner-with-us'
import {getTranslation} from '~/localization/translation'
import type {RootLoaderResponse} from '~/types'

const DwsPartnerBanner = () => {
  const {language} = useRouteLoaderData('root') as RootLoaderResponse
  const translations = getTranslation(language)
  const [showBunner, setShowBunner] = useState(false)

  useEffect(() => {
    if (typeof Storage != 'undefined' && !localStorage.getItem('dws-partner-banner')) {
      setShowBunner(true)
    }
  }, [])

  return showBunner ? (
    <div
      data-testid="dws-partner-banner"
      className="absolute right-10 top-28 flex min-h-[140px] min-w-[390px] self-end rounded-xl bg-[#e7f2f3] mobile:relative mobile:right-0 mobile:top-0 mobile:min-w-full mobile:rounded-none"
    >
      <button
        className="absolute right-3 top-3 z-20 cursor-pointer"
        aria-label='Close "Partner with us" banner'
        type="button"
        onClick={() => {
          if (typeof Storage != 'undefined') {
            localStorage.setItem('dws-partner-banner', 'seen')
          }
          setShowBunner(false)
        }}
      >
        <BrgIconClose fill="black" className="h-[14px] w-[14px]" />
      </button>
      <div className="mobile:py-auto flex h-full flex-col justify-between gap-1 py-4 pl-6 pr-16 mobile:justify-center mobile:pl-2 mobile:pr-10">
        <p className="z-20 text-3xl font-bold">{translations.PartnershipBanner.title}</p>
        <p className="z-20 text-lg">{translations.PartnershipBanner.subtitle}</p>
        <a
          href="https://roundforest.com/sellers/?utm_source=BRG&utm_medium=web&utm_campaign=popup"
          target="_blank"
          rel="noreferrer"
          className="z-20 cursor-pointer text-base underline"
          aria-label='Learn more about "Partner with us"'
        >
          {translations.PartnershipBanner.subtitleLink}
        </a>
      </div>
      <BrgIconPartnerWithUs className="absolute right-0 top-3 z-0 mobile:z-10" />
    </div>
  ) : null
}

export default DwsPartnerBanner
